module.exports = __webpack_public_path__ + "img/b3.36f05566.png";